(function ($, Global) {

    var engage;

    function PooolEngageComponent() {   
        // Déclaration class objet
    }

    PooolEngageComponent.prototype.initEvents = function () {
        if (Global.Engage == null || engage) return;

        try {

            engage = Global.Engage.init(Global.PAYWALL_TAG_ID).config({ cookies_enabled: true });

            if (engage == undefined) return;

            this.configAndCreate(engage);
            this.publishers();
        } catch (err) {
            console.error('Erreur lors de l\'initialisation de Poool Engage:', err);
        }
    }

    PooolEngageComponent.prototype.configAndCreate = function (engage) {
        var conditions = Global.ENGAGE_DISPLAY_CONDITIONS || [];
        engage.autoCreate({ filters: conditions })
    }

    PooolEngageComponent.prototype.publishers = function () {
        var self = this;
        engage.on('formSubmit', function (event) {
            var fields = event.fields;
            if (fields['formulaire'] == undefined) return;

            var form = fields['formulaire'];
            if (!['newsletter', 'creation-compte', 'creation-compte-nom'].includes(form)) return;

            if (form == 'newsletter') {
                self.subscribeNewsletter(event);
                return;
            }
            var prefix = '';

            var localPathName = Global.location.pathname.toLowerCase();
            if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
            if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

            self.register(event).then(function (result) {
                var invalid = [];
                if (result.errors && result.errors.Identifiant) {
                    invalid.push({ fieldKey: 'email', message: result.errors.Identifiant });
                    return invalid;
                }
                Global.ajaxCallback({
                    results: result,
                    success: function () {
                        Global.location.replace(prefix + '/SignUp/EmailValidationRequired?confirm');
                    }
                })
            })
        })
    }


    PooolEngageComponent.prototype.pushDataLayer = function () {
        Global.dataLayer.push({
            event: 'pooolActionEngage',
        });
    }

    PooolEngageComponent.prototype.subscribeNewsletter = function (event) {
        var formData = {
            Email: event.fields.email,
            Origin: 'PopUp',
            UrlPage: '/',
        };

        return $.ajaxPost('/ajax/form/newsletter', formData)
            .done(function (result) {
                Global.ajaxCallback({
                    results: result,
                    success: function (res) {
                        if (res.data.redirect != null) {
                            Global.location.replace(res.data.redirect);
                        }
                    }
                })
            })
    }

    PooolEngageComponent.prototype.register = function (event) {
        var formRegister = {
            Nom: event.fields.name,
            Prenom: event.fields.firstname,
            Identifiant: event.fields.email,
            MotDePasse: event.fields.password,
            MotDePasseConfirmation: event.fields.passwordValidation,
            UrlCreation: Global.PAYWALL_URL_CREATION,
            Redirect: Global.PAYWALL_USER_REDIRECT,
            IdArticle: Global.PAYWALL_ARTICLE_ID,
            CategoriePage: $('meta[name="CategoryPage"]').attr('content')
        };

        return $.ajaxPost('/ajax/login/create', formRegister)
            .done(function (result) {
                return result;
            });
    }

    Global.PooolEngageComponent = PooolEngageComponent;
} (jQuery, window));